import React, { Fragment, useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux'
import { useParams, Navigate, Link } from "react-router-dom";
import {Helmet} from "react-helmet"

import local from './local/login_localisation';

var msg = null;


import { SET_UNAME, SET_LOGED } from '../../redux/reducers/site';

export default function Login(){
    const dispatch = useDispatch()
    const [AllIs, setAllIs] = useState({done:false, error:null, open:true, pshow:true});
    const [password, setPass] = useState(null);
    const [msg, setMsg] = useState('ok');
    const setup = useSelector(state => state.site.setup);
    

    
    let { base, id } = useParams();


const open = () => setAllIs({loading:false, error:null, open:true}) 
const toggle = () => AllIs.pshow ? setAllIs({...AllIs, pshow:false}) : setAllIs({...AllIs, pshow:true})

const handleOnChange = (ev) => {
    const { value, name } = ev.target
    setPass( value )
  }


if(AllIs.error){
    return (
        <Fragment>
            <Fragment>
                <div className="login" onClick={toggle}>ASK QST: {AllIs.error.message}</div>
            </Fragment>
        </Fragment>
    )
} 

if(AllIs.done){
    return(  
    <Fragment>
           <Navigate to={'/'+setup.lang+'/user'} replace={true} />
    </Fragment>
)
} 
localStorage.clear();


let LANG = setup.lang;


return(
<Fragment>
    <Helmet>
        <title>{local[LANG].title}</title>
        <meta name="description" content={local[LANG].description} />
        <meta name="keywords" content={local[LANG].keywords} />
      </Helmet>
    <Fragment>
        <form name="login" onSubmit={(ev)=>{SaveDATA(ev)}} className="login pt10">
        { msg !=='ok' ? <p>{msg}</p> : null}
        <h2>{local[LANG].form_ttl}</h2>
        <input required type="username" name="username" placeholder={local[LANG].username} autoComplete='on'/>
        <div className='password'>
                  { AllIs.pshow? 
                          <Fragment>
                              <input required type="password" placeholder={local[LANG].password} onChange={handleOnChange}/>
                              <img src={setup.domen+'svg/pHide.svg'} className='ptoggler' onClick={toggle}/>
                          </Fragment> 
                  :
                          <Fragment>
                            <input required type="text" placeholder={local[LANG].password} onChange={handleOnChange}/>
                            <img src={setup.domen+'svg/pShow.svg'} className='ptoggler' onClick={toggle}/>
                          </Fragment>
                  }
        </div>
        <br/>

        <br/>
        <Link to={'/'+setup.lang+'/precovery'}>{local[LANG].precovery}</Link>
        <button type="submit" className="btn submit w50">{local[LANG].sbmt}</button>
        </form>
    </Fragment>
</Fragment>
 )   

 function SaveDATA(ev){
    ev.preventDefault()
    var sndForm = document.forms.login;

    const form = new FormData()
          form.append('lang', setup.lang);
          form.append('user', sndForm.elements.username.value);
          form.append('pass', password);
          //form.append('txt', sndForm.elements.text.value);
    const MyInit = { 
                method: 'POST',
                body: form
                };
  fetch(setup.domen+setup.folder+'login', MyInit)
    .then(response => {
        if (response.ok) {
          return response.json();
        } else {
          throw new Error(response.text()+'Something went wrong ...');
        }
    })
    .then(data => {
        let msg = data.resp;
        if(msg ==='ok'){
            //AllIs.done = true;
            localStorage.setItem('uloged', true);
            localStorage.setItem('user', JSON.stringify(data.user));
            setAllIs({...AllIs, done:true});
            dispatch(SET_UNAME(data.user.fio));
            dispatch(SET_LOGED(true));
        } else {
            //setMsg({...AllIs, error:{message:msg}});
            setMsg(msg);
        }
        
    })
    .catch(error => {
        setAllIs({...AllIs, error:error});
    });
  }


} //************ */